import { render, staticRenderFns } from "./GeneralUserData.vue?vue&type=template&id=ed0cbf3a&"
import script from "./GeneralUserData.vue?vue&type=script&lang=js&"
export * from "./GeneralUserData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports